import create from "zustand";
import api from "../../../api";
import { toast } from "react-toastify";
import { config } from "../alerts/index";
export const useStore = create((set, get) => ({
  orderInfo: null,
  confirmDelivery: (payload) => {
    set({ orderInfo: payload });
  },
  submitOrder: async (linesRemove, lines, setLoading) => {
    try {
      console.log("GET ORDER INFO: ",get().orderInfo);
      let lineItems = [];
      let deleteItems = [];
      get().orderInfo.products.map((product) => {
        if (
          !product.merchandise.availableForSale ||
          product.merchandise.inventory_quantity == 0
        ) {
          throw new Error("Out of Stock");
        }
        lineItems.push({
          variant_id: product.merchandise.id.replace(
            "gid://shopify/ProductVariant/",""
          ),
          quantity: product.quantity,
        });
      });
      const response = await api.orderCreation({
        order: {
          email: get().orderInfo.email,
          phone: get().orderInfo.phone,
          financial_status: "pending",
          shipping_address: {
            first_name: get().orderInfo.firstName,
            last_name: get().orderInfo.lastName,
            address1: get().orderInfo.address,
            phone: get().orderInfo.phone,
            city: get().orderInfo.city,
            zip: get().orderInfo.postalCode,
            province: get().orderInfo.province,
            country: "South Africa",
            company: get().orderInfo.storeName,
            name: get().orderInfo.firstName + " " + get().orderInfo.lastName,
          },
          billing_address: {
            first_name: get().orderInfo.firstName,
            last_name: get().orderInfo.lastName,
            address1: get().orderInfo.address,
            phone: get().orderInfo.phone,
            city: get().orderInfo.city,
            zip: get().orderInfo.postalCode,
            province: get().orderInfo.province,
            country: "South Africa",
            company: get().orderInfo.storeName,
            name: get().orderInfo.firstName + " " + get().orderInfo.lastName,
          },
          // Need to fix (put in a loop)
          line_items: lineItems,
          inventory_behaviour: "decrement_obeying_policy",
          send_receipt: true,
        }
      });
      lines.map((line) => {
        deleteItems.push(line.id);
      });
      linesRemove(deleteItems);
      toast("Your order has been placed!", { ...config, type: "success" });
      window.open(response.data.order.order_status_url, "_blank");
    } catch (error) {
      console.log("ERROR: ",error);
      setLoading(false);
    }
  }
}));
